import gql from 'graphql-tag';

export const updateMocEventCategory = gql`
  mutation updateMOCEventCategory($id: String, $changes: MOCEventCatInput) {
    updateMOCEventCategory(id: $id, changes: $changes) {
      id
      name
      enabled
      createdAt
      updatedAt
      deletedAt
      version
      businessUnits {
        name
        id
      }
    }
  }
`;
